import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import TabsSection from "../../Components/Tabs/TabsSection";
import SideBar from "../SideBar/SideBar";
import { MangeUsers } from "./MangeUsers";
import { LoginHistory } from "./LoginHistory";
import BackButton from "../BackButton/BackButton";

export const UserAdministration = () => {
  const [currentTab, setcurrentTab] = useState("");
  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    if (endPath[4] === "manage_users") {
      setcurrentTab("manage_users");
    }
    if (endPath[4] === "login_history") {
      setcurrentTab("login_history");
    }
  }, [path]);

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">User Administration</p>
          <div className="acc-dashboard mt-4">
            <TabsSection />

            {/* start */}
            {currentTab == "manage_users" && <MangeUsers />}

            {currentTab == "login_history" && <LoginHistory />}

            {/* end */}
          </div>
        </div>
      </div>
    </>
  );
};
